import {call, select} from 'redux-saga/effects';
import {
  choosenPhoneNumberOuidSelector,
  internationalFormatPortabilityCharacteristicsSelector,
} from '../PhoneNumber';
import {
  customerOuidSelector,
  customerTaxExemptionsSelector,
} from '../../Customer/selectors';
import {newOfferOptionsSelector} from '../../NewOffer/selectors';
import {
  phoneNumbersSelector,
  phoneNumberSelector,
} from '../AvailablePhoneNumbers';
import {
  promotionSelector,
  godfatherExternalIdForActivateSimSelector,
} from '../Bonus';
import {selectedAgreementSpecificationsSelector} from '../../Agreements/selectors';
import {triggerProductOrderPolling} from '../../PollingOrder';
import {tripica} from '../../../api';
import config from '../../../config';
import Toast from '../../../lib/toastService';
import Trpc from 'digicel-kaizen-library/lib/tripica-library';
import I18n from '../../../lib/i18n';
import {freeTrialActivationBonusStateSelector} from '../../Bonuses';
import WizzeeLog from '../../../lib/wizzeeLog';

/*
 * Initialize subscription related products (sub, options, promo...) to be activated later.
 * It's called when the customer order a sim or
 * activate a subscription during a roadshow.
 */
export function* initializeSubscription(): Generator<*, *, *> {
  try {
    const portabilityCharacteristics = yield select(
      internationalFormatPortabilityCharacteristicsSelector,
    );
    let phoneNumberOuid;
    if (portabilityCharacteristics && config.useTemporaryMsisdn) {
      const phoneNumbers = yield select(phoneNumbersSelector);
      phoneNumberOuid = phoneNumbers[0].ouid;
    } else {
      phoneNumberOuid = yield select(choosenPhoneNumberOuidSelector);
    }
    const promotion = yield select(promotionSelector);
    const formatedProductOfferings = [];
    const catalog = yield call([tripica, 'getCatalog']);
    if (catalog.allOptions) {
      const options = yield select(newOfferOptionsSelector);
      const orderableOptions = options.filter(
        opt => opt.ouid && opt.characteristic?.value !== '0',
      );
      orderableOptions.forEach(option => {
        //$FlowFixMe
        const formatedProductOffering = Trpc.getCatalogByProductName(
          option.name,
          catalog.allOptions[option.type],
        );
        formatedProductOfferings.push(formatedProductOffering);
      });
    }
    if (promotion && promotion.formatedProductOffering) {
      formatedProductOfferings.push(promotion.formatedProductOffering);
    }

    const customerOuid = yield select(customerOuidSelector);
    const taxExemptions = yield select(customerTaxExemptionsSelector);

    //temporary, to be fixed, when the back will be ready
    const billingAccountOuid = '0';

    const phoneNumber = yield select(phoneNumberSelector, phoneNumberOuid);

    const agreementSpecifications = yield select(
      selectedAgreementSpecificationsSelector,
    );
    const godfatherExternalIdValue = yield select(
      godfatherExternalIdForActivateSimSelector,
    );

    let bonus = godfatherExternalIdValue
      ? {godfatherExternalId: godfatherExternalIdValue}
      : undefined;

    // Checking if free trial bonus is available
    let freeTrialEnabled = false;
    const freeTrialActivationBonus = yield select(
      freeTrialActivationBonusStateSelector,
    );
    WizzeeLog.log('>>> initializeSubscription() - freeTrialActivationBonus :: ', JSON.stringify(freeTrialActivationBonus));
    // Checking if FREE_TRIAL product is available in the catalog
    if (freeTrialActivationBonus && !!freeTrialActivationBonus.freeTrial) {
      const response = yield call(
        [tripica, 'isActivationBonusEligible'],
        catalog,
      );
      if (response) {
        freeTrialEnabled = true;
        bonus = (bonus === undefined) 
        ? {godfatherExternalId: null, activationBonus: freeTrialEnabled} 
        : {godfatherExternalId: godfatherExternalIdValue, activationBonus: freeTrialEnabled }
      }
    }
    WizzeeLog.log('>>> initializeSubscription() - freeTrialEnabled :: ', freeTrialEnabled);

    if (!customerOuid) {
      return;
    }

    const response = yield call(
      [tripica, 'initializeSubscription'],
      customerOuid,
      billingAccountOuid,
      'unused',
      formatedProductOfferings,
      catalog,
      taxExemptions,
      phoneNumberOuid,
      phoneNumber.phoneNumber,
      agreementSpecifications,
      bonus,
      portabilityCharacteristics,
    );

    if (!response || !response.errorCodeList) {
      throw new Error('No response or errorCodeList');
    }

    if (response.status === 'VALIDATED') {
      const subscriptionOrder = yield call(
        triggerProductOrderPolling,
        response.uuid,
      );
      const subscriptionProduct = subscriptionOrder?.orderItems?.find(
        orderItem => orderItem.product.name.includes('SUB'),
      )?.product;
      return subscriptionProduct;
    } else {
      yield call(Toast.showError, I18n.t('error.orderFailed'));
    }
  } catch (e) {
    WizzeeLog.warn('[saga] initializeSubscription', e);
    Toast.showError(e);
  }
}
